import { WebinarInfo } from "@api/models/WebinarInfo";
import { Element } from "@api/models/Element";
import { getYouTubeUrl } from "@common/urlHelper"
import { OnlineProvider } from "@api/enums/Session/OnlineProviderEnum";

export class WebinarInfoHelper {
    public static getWebinarInfo(item: Element): WebinarInfo | null {

        if (item.onlineParams?.youTube) {
            return new WebinarInfo({
                onlineProvider: OnlineProvider.youTube,
                usersOnlineCount: 0,
                youTube: { url: item.onlineParams?.youTube?.url, iframeUrl: getYouTubeUrl(item.onlineParams?.youTube.url) }
            })
        }
        else if (item.onlineParams?.custom) {
            return new WebinarInfo({
                onlineProvider: OnlineProvider.custom,
                usersOnlineCount: 0,
                custom: { url: item.onlineParams?.custom.url }
            })
        }

        return null;
    }
}